import { Component, input, inject, ChangeDetectionStrategy, signal, effect } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  FormSectionComponent,
  TextareaFieldWithErrorComponent,
  TextFieldWithErrorComponent
} from 'htx-ui-library';
import { FormErrorMessagesService } from '../../../../services/form/form-error-messages.service';

@Component({
  selector: 'app-registration-step-2-organisation',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    FormSectionComponent,
    TextFieldWithErrorComponent,
    TextareaFieldWithErrorComponent
  ],
  templateUrl: './registration-step-2-organisation.component.html',
  styleUrl: './registration-step-2-organisation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationStep2OrganisationComponent {
  readonly organisationForm = input.required<FormGroup>();
  readonly organisationFormFieldLabels = input.required<{ [key: string]: string }>();
  readonly errorMessagesService = inject(FormErrorMessagesService);

  readonly descriptionCharCount = signal(0);
  readonly descriptionMaxLength = 500;

  constructor() {
    effect(() => {
      const form = this.organisationForm();
      const descriptionControl = form.get('description');

      if (descriptionControl) {
        // Subscribe to value changes
        const subscription = descriptionControl.valueChanges.subscribe(value => {
          this.descriptionCharCount.set(value?.length || 0);
        });
        // Set initial value
        this.descriptionCharCount.set(descriptionControl.value?.length || 0);

        // Cleanup subscription when effect re-runs
        return () => subscription.unsubscribe();
      }

      return () => {};
    });
  }
}
